<template>
  <div
    :class="[
      'loader',
      'loader--dots-active',
      {
        'loader--messages': messages
      }
    ]"
  >
    <div class="loader__items">
      <div class="message__block" :style="[wrapperStyle]"/>
      <module-messages v-if="messages" :messages="messages" @messages-height="getMessageHeight" @messages-complete="onMessagesComplete"/>
      <module-dots />
    </div>
  </div>
</template>

<script>
// Vuex
import { mapGetters } from 'vuex';

// Modules
import ModuleDots from 'components/Dots';
import ModuleMessages from 'components/LoaderMessages';

export default {
  name: 'ui-module-loader',

  // Components
  components: {
    ModuleDots,
    ModuleMessages,
  },

  // Props
  props: {
    messages: Array,
  },

  data() {
    return {
      okToLoad: false,
    };
  },

  computed: {
    ...mapGetters('app', [
      'appState',
      'appPage',
    ]),
    wrapperStyle() {
      return {
        'height': `${this.messageHeight}px`,
      };
    },
    messageHeight(value) {
      if(typeof value === 'number') {
        return value;
      }
    },
  },

  watch: {
    'appPage.fullPath'() {
      if(this.messages) {
        this.triggerMessages();
      }
    },
  },

  // Methods
  methods: {

    getMessageHeight(value) {
      if(typeof value === 'number') {
        this.offsetHeight = value;
      }
    },

    onMessagesComplete() {
      this.$emit('messages-complete');
    },
  },
};

</script>



// WEBPACK FOOTER //
// ModuleLoader.vue?01481a2d